export const environment:any = {
    production: false,
    apiToken: 'm8pd0QRide4KH3tJHRmCBbDx0gbdlOrZVUTU0IfI',
    apiUrl: 'https://pioneer.pioneerassociate1234.com.np/pioneerapi/api/v1',
    imageUrl: 'https://pioneer.pioneerassociate1234.com.np/pioneerapi/assets/images',
};
